const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/audit/$entityId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requirePermission } from '@/common/hooks/usePermissions';
const searchSchema = z.object({
  entityType: z.string().min(1)
});
export const Route = createFileRoute('/(app)/org/$org/audit/$entityId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: searchSchema,
  beforeLoad: requirePermission('edit_organization')
});